export default __webpack_public_path__ + "static/media/vid7.04eb2cd3.mp4";